import React from "react";
import "./Eachpricing.css";
import { RiCheckboxCircleFill } from "react-icons/ri";
const EachPricing = ({value}) => {
    const {title,tag,price,features} = value
  return (
    <div className="price-card">
      <div className="price-header">
        <h4>{title}</h4>
        <p className="card-title">{tag}</p>
        <div className="price-amount">
          <span>$</span>
          <p className="price-rs">{price}</p>
        </div>
      </div>
      <div className="price-body">
          <ul>
              {features.map((item,index)=>{
                  return <li key={index}><RiCheckboxCircleFill className="checkbox-icon"/>{item}</li>
              })}

        
          </ul>
      </div>
      <div className="price-footer">
          <button>Get Started</button>
      </div>
    </div>
  );
};

export default EachPricing;
